<template>
    
  <div class="container">
      <div class="row col-md-9 mx-auto my-5">
          <h2 class="mt-5" style="font-weight: bold;">آزمون های ناباکو</h2>
          <div class="my-5">
                
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-center my-auto">
                      <h4 class="fw-bold">آزمون سرمایه گذاری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                          لطفاً اطلاعات زیر را با دقت تکمیل کنید تا تیم ما بتواند بهترین راه‌حل‌ها را برای شما ارائه دهد
                        </h6>
                        <button class="btn-gold my-2">
                          <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">لینک آزمون</a>
                        </button>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../assets/services-img/img14.svg" class="w-75" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-center d-md-block d-none">
                        <img src="../assets/services-img/Business2.svg" class="w-75" alt="">
                    </div>
                    <div class="col-md-7 text-center mt-5">
                      <h4 class="fw-bold">آزمون تریدر</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                          لطفاً اطلاعات زیر را با دقت تکمیل کنید تا تیم ما بتواند بهترین راه‌حل‌ها را برای شما ارائه دهد
                        </h6>
                        <button class="btn-gold my-2">
                          <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">لینک آزمون</a>
                        </button>
                      </div>
                      <div class="col-md-5 my-auto text-end d-md-none d-block">
                          <img src="../assets/services-img/Business2.svg" class="w-75" alt="">
                      </div>
                </div>
            </div>
      </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  components:{},
  setup() {
      library.add(faSlash)

      return {

      }
  }
})
</script>
<style lang="scss" scoped>
.card {
  border: solid 1px #cfcfcf;
}
</style>